import { FC, useState } from "react"
import './login.css'
import api from "../../../services/api"
import { usePluginspace } from "../../../hooks/usePluginspace"
import Swal from 'sweetalert2';
import { useNavigate, useParams } from "react-router-dom"
import { useAppConfig } from "../../../hooks/useAppConfig"
import { Loading } from "../../../components/Loading"
import { DecodedTokenData } from "../../../contexts/authContext"
import { parseJwt } from "../../../functions/util"
import useAuth from "../../../hooks/useAuth"
import { useConfig } from "../Auth"
import { ForgotPassword } from "../resetPassword/reset";

const Login: FC<any> = ({ configPlugin }) => {
    const [email, setEmail] = useState<string>('')
    const [password, setPassword] = useState<string>('')
    const [categoryId, setCategoryId] = useState('');
    const { getAppConfig } = useAppConfig();
    const navigate = useNavigate();
    const params = useParams();
    const [loading, setLoading] = useState(false);
    const { setToken, setPluginspaceData } = usePluginspace()
    const { setLoginInfo } = useAuth()

    const { config } = useConfig();
    const [toReset, setToReset] = useState(false);

    async function enter() {
        const config = await getAppConfig()


        if (config && (config.template === "retail" || config.template === "food")) {
            if (config.content.pdv.showLayout === 'l2') {
                navigate(`/${params.pluginspace_id}/products-new`);
            } else {
                navigate(`/${params.pluginspace_id}/products`);
            }
        } else {
            navigate(`/${params.pluginspace_id}/category`);
        }
    }

    async function login() {


        if (email || password) {
            setLoading(true);
            return await api.post(`/api/token/get-token`,
                {
                    subdomain: atob(window.location.pathname.split('/')[1]),
                    //To-do teste login custommer
                    email: Buffer.from(email).toString('base64'),
                    pwd: Buffer.from(password).toString('base64'),
                }).then(async (response) => {
                    if (process.env.REACT_APP_JWT_SALT && !response.data.status) {
                        localStorage.setItem('loginInfo', JSON.stringify(response.data.accessToken))
                        const tkNoSalt = response.data.accessToken.split(process.env.REACT_APP_JWT_SALT).join('')
                        const tk: DecodedTokenData | null = parseJwt(tkNoSalt)
                        if (tk) {
                            setLoginInfo({
                                accessToken: response.data.accessToken,
                                expiratedAt: response.data.expiratedAt,
                                identifier: tk.identifier,
                                id: tk.id,
                                email: tk.email,
                                plugintype: tk.plugintype,
                                pluginspaceId: tk.pluginspaceId,
                                plugintypeId: tk.plugintypeId,
                                profile: tk.profile,
                            })

                            setPluginspaceData(tk?.pluginspaceId)
                            //setToken(response.data.accessToken);
                            enter()
                        }
                    } else {
                        setLoading(false);
                        let message = 'Usuário não encontrado.'
                        if (response.data.message === 'Customer is not valid.') {
                            message = 'Usuário não validado, favor terminar seu cadastro'
                        }

                        Swal.fire({
                            icon: 'error',
                            title: 'Atenção!',
                            text: message,
                        })
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    Swal.fire({
                        icon: 'error',
                        title: 'Atenção!',
                        text: 'Usuário não encontrado.',
                    })

                })
        } else {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Verifique se preencheu email ou senha e tente novamente.',
            })
        }
    }

    return (
        <div className={`contentLogin`} >
            {loading ? (
                <div style={{ width: '100%', height: 'calc(100vh)', position: 'absolute', top: '0', left: '0' }}>
                    <Loading
                        type="spinningBubbles"
                        color="#FFF"
                        width={64}
                        height={64}
                    />
                </div>
            ) : (
                <>
                    <div className={`contentLogin-Principal ${toReset ? 'itens-sobrepostos' : ''}`}>
                        <div className="contentLogin-Header">
                            <h1
                                style={{
                                    color: config?.webappcolor?.webappbutton ? config?.webappcolor?.webappbutton : 'black'
                                }}>Olá!</h1>

                            <span>Acesse sua conta para gerenciar compras e personalizar a sua experiência</span>
                        </div>

                        <div className="contentLogin-Inputs">

                            <div className="email">
                                <div className="email-header">
                                    <label>Email</label>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                                        <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                                    </svg>
                                </div>

                                <div className="email-Input">
                                    <input
                                        className="myinput"
                                        type="email"
                                        placeholder={'Email'}
                                        value={email}
                                        onChange={(event) => setEmail(event.target.value)}
                                    />

                                </div>
                            </div>

                            <div className="senha">
                                <div className="senha-header">
                                    <label>Senha</label>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                                        <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                                    </svg>
                                </div>
                                <div className="password-Input">
                                    <input
                                        className="myinput"
                                        type="password"
                                        placeholder={"*******"}
                                        value={password}
                                        onChange={(event) => setPassword(event.target.value)}
                                    />


                                </div>
                            </div>


                            <button className="button"
                                style={{
                                    background: config?.webappcolor?.webappbutton ? config?.webappcolor?.webappbutton : 'rgb(7, 139, 216)',
                                    border: "none",
                                }}
                                onClick={() => login()}

                            >Entrar</button>

                            <div className="esqueciSenha">
                                <span onClick={() => setToReset(true)}>Esqueci a senha</span>
                            </div>
                        </div>
                    </div>

                    <div className="contentLogin-bottom">
                        <span className="cadastro">Ainda não tem cadastro?</span>
                        <span className="link">É simples criar sua conta no Ninegrid. <a onClick={() => navigate(`/${params.pluginspace_id}/register`)}>Vamos começar?</a></span>
                    </div>
                </>
            )

            }

            {toReset && (
                <div className="reset-password">
                    <ForgotPassword close={() => setToReset(false)} />
                </div>
            )

            }


        </div>
    )
}


export { Login }